import Vue from 'vue';
import DialogStateMixin from '@/helpers/vue_mixins/v2/DialogStateMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import ActionButton from '@/components/action_button/Index.vue';
import AppLatestBilling from '@/plugins/graphql/queries/v2/app-latest-billing.gql';
import '@/assets/stylesheets/v2/_deactivation_notice.scss';
import { BillingBasicModel } from '@/helpers/entities/models/BillingBasicModel';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import GracePeriodActivation from '@/components/v2/GracePeriodActivation.vue';
import { mapGetters, mapMutations } from 'vuex';
/**
 * Mini App Deactivation Notifier
 * Toggle This Notifier when mini app is deactivated and if user navigate from
 * App Dashboard
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.14.0}
 */
export default Vue.extend({
    apollo: {
        billing: {
            query: AppLatestBilling,
            variables() {
                return {
                    appUuid: this.appUUID,
                };
            },
            update({ appLatestBilling }) {
                return new BillingBasicModel(appLatestBilling);
            },
        },
    },
    components: {
        AppBasicDetails,
        BaseSubtitle,
        ActionButton,
        GracePeriodActivation,
    },
    mixins: [DialogStateMixin, RouterParamsAppMixin],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            billing: null,
        };
    },
    computed: {
        ...mapGetters(['hideDeactivationReminder']),
        amount() {
            const self = this;
            const options = self.$options;
            if (!!options && !!options.filters && !!options.filters.currency && self.billing) {
                return options.filters.currency(self.billing.amount);
            }
            return '0.0';
        },
    },
    watch: {
        /**
         * Watch hideDeactivationReminder state changes
         * Hide Dialog when state is set to true and then revert state via
         * hideDeactivationReminderDialog mutation
         * @author Peter John Alvarado <peterjohn@gorated.ph>
         * @since Version {0.15.0}
         */
        hideDeactivationReminder(val) {
            if (val) {
                const self = this;
                self.hideDialog();
                self.hideDeactivationReminderDialog(false);
            }
        },
    },
    created() {
        this.toggle = this.show;
    },
    methods: {
        ...mapMutations(['hideDeactivationReminderDialog']),
        goToBillDetails() {
            this.$router.push({
                name: 'billing-details',
                params: { uuid: this.billing.uuid },
            });
            this.hideDialog();
        },
    },
    render(createElement) {
        const self = this;
        const cardContent = () => {
            return createElement('v-card', { class: 'card pa-4' }, [
                createElement('v-btn', { props: { icon: true }, class: 'close', on: { click: self.hideDialog } }, [createElement('v-icon', ['close'])]),
                createElement('v-layout', { class: 'column align-center justify-center' }, [
                    createElement('v-flex', { class: 'shrink mt-5 mb-4' }, [
                        createElement('v-img', {
                            props: {
                                src: require('@/assets/images/deactivate.svg'),
                                height: 102,
                                width: 102,
                            },
                        }),
                    ]),
                    createElement('v-flex', { class: 'mb-4' }, [
                        createElement('base-subtitle', { props: { text: 'In-App Store Deactivation Notice' } }),
                    ]),
                    createElement('v-flex', { props: { fontSize14: true } }, [
                        createElement('base-text', {
                            props: {
                                text: 'Please settle your payments to continue using your In-App Store.',
                            },
                            class: 'text-xs-center',
                        }),
                    ]),
                    createElement('v-flex', { props: { fontSize14: true }, class: 'my-5' }, [
                        createElement('base-text', {
                            props: {
                                text: `Total Balance: ₱${self.billing.accumulatedAmount}`,
                            },
                        }),
                    ]),
                    createElement('v-flex', { class: 'mb-3' }, [
                        createElement('v-layout', [
                            createElement('v-flex', [
                                createElement('action-button', {
                                    props: { orangeTheme: true, submit: true },
                                    on: { wasClicked: self.goToBillDetails },
                                    attrs: { id: 'viewBill' },
                                }, ['View Bill']),
                            ]),
                            createElement('v-flex', [
                                createElement('app-basic-details', {
                                    props: { appUuid: self.appUUID },
                                    ref: 'appDetails',
                                    attrs: { id: 'appDetails' },
                                    scopedSlots: {
                                        default: (props) => {
                                            const { app } = props;
                                            if (!!app &&
                                                app.deactivated &&
                                                !self.billing.disabled &&
                                                !self.billing.gracePeriodActivated) {
                                                return createElement('grace-period-activation', {
                                                    props: { uuid: self.billing.uuid, deactivationPage: true },
                                                    attrs: { id: 'activateGracePeriod' },
                                                });
                                            }
                                        },
                                    },
                                }),
                            ]),
                        ]),
                    ]),
                ]),
            ]);
        };
        const loader = () => {
            return createElement('v-card', { class: 'card pa-4' }, [createElement('base-inner-loader')]);
        };
        const content = () => (this.billing ? cardContent() : loader());
        return createElement('v-dialog', {
            props: {
                value: self.toggle,
                width: 400,
                persistent: true,
                contentClass: 'deactivation-notice',
            },
        }, [content()]);
    },
});
